import React, { useState } from "react";
import "./css/whatWeDo.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { apiUrl } from "../config/api";

// Card component
const Card = ({ title, content, image }) => (
  <div className="card">
    {image && (
      <div className="card-image">
        <img src={apiUrl(image)} alt={title} />
      </div>
    )}
    <div className="card-left">
      <h3 className="card-title">{title}</h3>
    </div>
    <div className="card-right">
      <p className="card-content">{content}</p>
    </div>
  </div>
);

const WhatWeDo = () => {
  // ✅ Initialize state with the array and sort it by 'order'
  const [items] = useState([
    {
      id: 28,
      section: "what_we_do",
      heading: "WTO/SPS inquiry point",
      url_link: null,
      content:
        "Designated body or contact point established under the World Trade Organization (WTO) framework to provide information and handle inquiries related to Sanitary and Phytosanitary (SPS) Measures in international trade.",
      image: null,
      order: 13,
    },
    {
      id: 25,
      section: "what_we_do",
      heading: "Verification and calibration services",
      url_link: null,
      content:
        "Ensuring the accuracy and reliability of measurement instruments, equipment, and systems used in various industries.",
      image: null,
      order: 12,
    },
    {
      id: 24,
      section: "what_we_do",
      heading: "Consumer complaints handling",
      url_link: null,
      content:
        "Safeguarding consumer rights, promoting product safety, and ensuring that businesses adhere to established standards.",
      image: null,
      order: 11,
    },
    {
      id: 23,
      section: "what_we_do",
      heading: "Product certification and Inspectorate services",
      url_link: null,
      content:
        "Integral components of the national regulatory framework designed to ensure that products meet established standards for quality, safety, and performance.",
      image: null,
      order: 10,
    },
    {
      id: 22,
      section: "what_we_do",
      heading: "Testing Services",
      url_link: null,
      content:
        "MBS evaluates the quality, safety, and performance of products, materials, or processes to ensure they meet specific standards and regulatory requirements.",
      image: null,
      order: 9,
    },
    {
      id: 21,
      section: "what_we_do",
      heading: "Develop and review Malawi standards",
      url_link: null,
      content:
        "Create, update, and refine national standards for various products, services, processes, and systems in Malawi.",
      image: null,
      order: 8,
    },
  ].sort((a, b) => a.order - b.order)); // ✅ sort by order ascending

  return (
    <div className="what-we-do">
      <h2 className="heading">
        <span className="line"></span>
        WHAT WE DO
        <span className="line"></span>
      </h2>

      {items.length === 0 ? (
        <p className="text-center text-muted mt-3">No items available.</p>
      ) : (
        <div className="cards-grid">
          {items.map((item) => (
            <Card
              key={item.id}
              title={item.heading}
              content={item.content}
              image={item.image}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default WhatWeDo;



// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./css/whatWeDo.css";
// import "bootstrap/dist/css/bootstrap.min.css";

// const Card = ({ title, content, image }) => (
//   <div className="card">
//     {image && (
//       <div className="card-image">
//         <img src={`http://192.168.0.5:8004/${image}`} alt={title} />
//       </div>
//     )}
//     <div className="card-left">
//       <h3 className="card-title">{title}</h3>
//     </div>
//     <div className="card-right">
//       <p className="card-content">{content}</p>
//     </div>
//   </div>
// );

// const WhatWeDo = () => {
//   const [items, setItems] = useState([]);

//  useEffect(() => {
//     axios
//       .get("http://192.168.0.5:8004/api/home-sections/what_we_do")
//       .then((res) => {
//         console.log("Fetched data:", res.data);

//         // ✅ Sort items by "order" ascending
//         const sortedItems = [...res.data].sort((a, b) => a.order - b.order);

//         setItems(sortedItems);
//       })
//       .catch((err) => console.error("Error fetching What We Do:", err));
//   }, []);

//   return (
//     <div className="what-we-do">
//       <h2 className="heading">
//         <span className="line"></span>
//         WHAT WE DO
//         <span className="line"></span>
//       </h2>

//       {items.length === 0 ? (
//         <p className="text-center text-muted mt-3">No items available.</p>
//       ) : (
//         <div className="cards-grid">
//           {items.map((item, index) => (
//             <Card
//               key={index}
//               title={item.heading}
//               content={item.content}
//               image={item.image}
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default WhatWeDo;
